// V-Kit in the ChatGPT plugin directory (ADR-0066): the button under the ChatGPT guide.
import { t } from "../i18n";

/** V-Kit in the ChatGPT plugin directory (ADR-0066). */
export const CHATGPT_PLUGIN_URL = "https://chatgpt.com/plugins/plugin_asdk_app_6acc18d0fe108191b079513f43b725c9";

export function ChatgptPluginLink() {
  return (
    <a className="btn btn-primary" href={CHATGPT_PLUGIN_URL} target="_blank" rel="noreferrer" data-testid="chatgpt-plugin-button">
      {t("install.chatgptOpen")}
    </a>
  );
}
